import { BigNumber } from "ethers";
import React from "react";

export type AssetsContextValue = {
  balance?: BigNumber;
  formattedBalance?: string;
  honeyBalance?: BigNumber;
  readHoneyBalance: () => void;
  fancyBearsInWallet?: number[];
  fancyBearsInWalletCount?: number;
  readFancyBearsInWallet: () => void;
  honeyJarsInWallet?: number[];
  honeyJarsInWalletCount?: number;
  traitsInWallet?: number[];
  traitsInWalletCount?: number;
  readHoneyJarsInWallet: () => void;
};

const AssetsContext = React.createContext<AssetsContextValue>({
  readHoneyBalance: () => {},
  readFancyBearsInWallet: () => {},
  readHoneyJarsInWallet: () => {},
});

export default AssetsContext;
